import type { writeBody } from '@porotutu/api/features/adm/organizations/model'
import type {
  historyEntryResource,
  organizationResource,
} from '@porotutu/api/features/adm/organizations/resource'
import { historyQueries, readWriteQueries } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { adm } from '@/api/client'
import { ORGANIZATIONS } from '@/api/keys'
import type { OrganizationSort } from '../vocabulary'

export type Organization = ReturnType<typeof organizationResource>
export type HistoryEntry = ReturnType<typeof historyEntryResource>

export type OrganizationPage = { data: Organization[]; meta: ListMeta }

export type WriteOrganizationBody = typeof writeBody.static

export type OrganizationListQuery = ListQuery<OrganizationSort, never>

const collection = readWriteQueries<Organization, WriteOrganizationBody, OrganizationListQuery>({
  prefix: ORGANIZATIONS,
  routes: adm.organizations,
})

export const organizationsQuery = collection.listQuery
export const organizationQuery = collection.recordQuery
export const updateOrganizationMutation = collection.updateMutation
export const seedOrganization = collection.seed

export const organizationHistoryQuery = historyQueries<HistoryEntry>({
  prefix: ORGANIZATIONS,
  routes: adm.organizations,
})
